module.exports = __webpack_public_path__ + "static/img/ce-3.402898b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/ce-3.jpg
 ** module id = 574
 ** module chunks = 2
 **/